import { Box } from "@chakra-ui/react";

import {
  colors,
  getCdnImageSrc,
  HStack,
  VStack,
  Image,
  Spacing,
} from "goi_common";
import { Fragment } from "react";
import { 가족장2026 } from "goi_common/src/constants/servicePackages/service2026/가족장";

export default function ServiceInfoSection({
  details = 가족장2026.details,
  type = "가족장",
}: {
  details?: any;
  type?: string;
}) {
  return (
    <VStack padding="40px 0 20px" gap="60px">
      {details.map(({ key, contents }: { key: string; contents: any }) => (
        <DetailCard
          key={key + type}
          title={key}
          contents={contents}
          type={type}
        />
      ))}
    </VStack>
  );
}

function DetailCard({ title, contents, informationComponent, type }: any) {
  return (
    <VStack gap={24}>
      <VStack
        gap={6}
        background={colors.warmGray150}
        padding="10px 12px"
        borderRadius="5px"
      >
        <div className="subtitle_16_b">{title}</div>
      </VStack>
      {informationComponent}
      <HStack gap={"12px"} css={{ flexWrap: "wrap" }} padding="0px 12px">
        {contents.map((content: any) => (
          <Fragment key={content.title + type}>
            <VStack
              gap="10px"
              width={"calc(50% - 6px)"}
              key={content.title}
              position="relative"
            >
              <Image
                src={getCdnImageSrc(content.src)}
                width={"100%"}
                alt={content.title}
              />
              <VStack height="100%" justifyContent="space-between">
                <Box className={"subtitle_16_b"}>{content.title}</Box>
                <Box className={"body_14_m gray800"} whiteSpace="pre-line">
                  {content.descriptions}
                </Box>
                <Spacing gap={10} />
                <Box
                  className={"subtitle_18_b gray900"}
                  css={{ marginTop: "auto" }}
                >
                  {content.discountPrice > 0 ? (
                    <>{content.discountPrice.toLocaleString()} 원 </>
                  ) : content.price === 0 ? (
                    <>무료 제공</>
                  ) : (
                    <>{content.price.toLocaleString()} 원 </>
                  )}
                </Box>

                <Spacing gap={20} />
              </VStack>
            </VStack>
          </Fragment>
        ))}
      </HStack>
    </VStack>
  );
}
